import React, { useState, useRef, useEffect } from "react";
const toYouTubeEmbed = (url) => {
    if (!url) return null;

    if (url.includes("youtu.be/")) {
        return `https://www.youtube.com/embed/${url.split("youtu.be/")[1].split("?")[0]}`;
    }

    if (url.includes("watch?v=")) {
        return `https://www.youtube.com/embed/${url.split("watch?v=")[1].split("&")[0]}`;
    }

    return null;
};

const BlogDescriptionView = ({ raw }) => {
    if (!raw) return null;

    const content = typeof raw === "string" ? JSON.parse(raw) : raw;

    return (
        <div className="blog-description">
            {content.blocks.map((block, i) => {

                // 🎥 YOUTUBE / EMBED BLOCK
                if (block.type === "atomic") {
                    const entityKey = block.entityRanges?.[0]?.key;
                    const entity = raw.entityMap?.[entityKey];

                    if (entity?.type === "EMBEDDED_LINK") {
                        const embedUrl = toYouTubeEmbed(entity.data.src);

                        if (!embedUrl) return null;

                        return (
                            <div key={i} className="my-4 aspect-video bg-black/5 rounded">
                                <iframe
                                    src={embedUrl}
                                    className="w-full h-full rounded"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </div>
                        );
                    }
                }


                // 📝 NORMAL TEXT
                return null
            })}
        </div>
    );
};

export default BlogDescriptionView;
